module.exports = __webpack_public_path__ + "static/media/dnp-winner.1b5eec6e.jpg";